module.exports = __webpack_public_path__ + "img/12f.370a1be6.png";